import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../../components/template/authorization/Authorization";

export const initFilterInput = {
  search: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleEdit) => {
  return [
    {
      dataIndex: "key",
      key: "key",
      title: "Parameter",
    },
    {
      dataIndex: "value",
      key: "value",
      title: "Value",
      width: "10%",
    },
    {
      dataIndex: "desc",
      key: "desc",
      title: "Description",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_company_setting}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
